<template>
    <v-dialog ref="dialog" v-model="modal" persistent width="390px">
        <template v-if="!readonly" v-slot:activator="{ on }">
            <v-text-field class="date-picker" readonly v-model="selectedDate" :label="label" v-on="on"
                append-icon="mdi-calendar"></v-text-field>
        </template>
        <template v-else v-slot:activator="{  }">
            <v-text-field readonly v-model="selectedDate" :label="label"></v-text-field>
        </template>        

        <v-date-picker v-model="date" scrollable :locale="locale" >
            <v-spacer></v-spacer>
            <v-btn class="danger" @click="modal = false">{{cancel}}</v-btn>
            <v-btn @click="reset">{{clear}}</v-btn>
            <v-btn class="success" @click="save">{{confirm}}</v-btn>
        </v-date-picker>
    </v-dialog>
</template>

<script>
export default {
    name: "date-picker", 
    props:{
        label:{
            required: true, 
            type: String
        },
        readonly:{
            required: false,
            default: false,
            type: Boolean
        },        
        value:{
            required: false,
            type: Date
        },
        required:{
            required: false,
            type: Boolean
        },
        requiredText:{
            required: false, 
            type: String            
        }  
    },
    watch:{
        value(newValue){
            if(newValue != null)
                this.date = this.$moment(newValue).format("YYYY-MM-DD");
            else 
                this.date = null;
        }
    },
    data(){
        return {
            date: null,
            modal: false,
            locale: null
        }
    },
    computed: {  
        cancel () {
            return this.$t("Common.cancel");
        },
        clear () {
            return this.$t("Common.clear");
        },        
        confirm () {
            return this.$t("Common.confirm");
        },   
        selectedDate:{
            get () {
                if(this.date == null) return null;
                return this.$moment(this.date).format('L'); 
            },
            set (val) {
                this.date = val;
            }            
        }  
    },    
    async created(){
        this.$events.$on("locale-has-changed", this.setLocale);
        this.setLocale(this.$locale);
    },    
    beforeDestroy(){
        this.$events.$off("locale-has-changed", this.setLocale);
    },      
    methods:{
        setLocale(locale){
            switch(locale){
                case process.env.VUE_APP_DB_LOCALE_ES:
                    this.$moment.locale("es");   
                    this.locale = "es";

                    break;

                case process.env.VUE_APP_DB_LOCALE_EN:
                    this.$moment.locale("us");   
                    this.locale = "us";

                    break;

                default:
                    this.$moment.locale("pt-br"); 
                    this.locale = "pt-br";

                    break;                        
            }         
        },
        reset(){
            this.modal = false;
            this.date = null;
            this.$emit("input", null);
        },
        save(){
            this.modal = false;
            this.$emit("input", this.$moment(this.date).toDate());           
        }      
    }
}
</script>

<style lang="scss">
@import "../../styles/material-dashboard/variables";

.date-picker{
    .v-input__control{
        .v-input__append-inner{
            i{
                color: $brand-primary !important; 
            }
        }
    }
    .v-input__append-outer{
        i{
            color: $brand-danger !important; 
        }
    }
}
</style>
